import { Tab, Tabs, Typography } from "@mui/material"
import React from "react"
import { customPalette } from "../../../theme"

interface IProps {
  selectedTab: number
  labelLeft: string
  labelRight: string

  handleChangeTabs(event: React.SyntheticEvent, newValue: number): void
}

export function SwitchTab({ selectedTab, handleChangeTabs, labelLeft, labelRight }: Readonly<IProps>): React.JSX.Element {
  return (
    <Tabs
      value={selectedTab}
      onChange={handleChangeTabs}
      aria-label="Tabs to choose between RSEE document list or global dashboard"
      TabIndicatorProps={{ style: { display: "none" } }}
      sx={{
        mt: 1,
        p: 0.1,
        borderRadius: 5,
        border: 1,
        borderColor: customPalette.lightBlue4,
      }}>
      <Tab
        label={
          <Typography
            fontSize={14}
            fontWeight={500}
            sx={{
              color: selectedTab === 0 ? customPalette.black : customPalette.lightBlue2,
              textTransform: "none",
              whiteSpace: "nowrap",
            }}>
            {labelLeft}
          </Typography>
        }
        id="tab-0"
        sx={{ backgroundColor: selectedTab === 0 ? customPalette.lightBlue4 : "", borderRadius: 5 }}
      />
      <Tab
        label={
          <Typography
            fontSize={14}
            fontWeight={500}
            sx={{
              color: selectedTab === 1 ? customPalette.black : customPalette.lightBlue2,
              textTransform: "none",
              whiteSpace: "nowrap",
              minWidth: "auto",
            }}>
            {labelRight}
          </Typography>
        }
        id="tab-1"
        sx={{
          backgroundColor: selectedTab === 1 ? customPalette.lightBlue4 : "",
          borderRadius: 5,
        }}
      />
    </Tabs>
  )
}
